import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import './Product.css';
import { site_url, site_url_img } from "./../config.js";
import { Formik } from 'formik';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from './../AuthContext';
import { IndianCurrencyFormatter, FormatDate } from './../Function';
import * as bootstrap from 'bootstrap';
import { useLocation } from "react-router-dom";

export default function Index() {
    const { user, refreshUser, vendordetails ,fulluser} = useContext(AuthContext);

    const [selectedImage, setSelectedImage] = useState(null);
    const [categorydata, setcategorydata] = useState([]);
    const [image, setImage] = useState(null);
    const [productdata, setproductlist] = useState([]);
    const [editdetails, seteditdetails] = useState([]);
    const location = useLocation();



    const cleanupModalBody = () => {
        document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    };

    useEffect(() => {
        cleanupModalBody();
    }, [location]);

    useEffect(() => {
        const modalIds = ['withdrawActionSheet', 'withdrawActionSheeta'];
        const listeners = modalIds.map((id) => {
            const el = document.getElementById(id);
            if (!el) {
                return null;
            }
            const onHidden = () => cleanupModalBody();
            el.addEventListener('hidden.bs.modal', onHidden);
            return { el, onHidden };
        });

        return () => {
            listeners.forEach((entry) => {
                if (entry) {
                    entry.el.removeEventListener('hidden.bs.modal', entry.onHidden);
                }
            });
        };
    }, []);

    const closeProductModal = (modalId) => {
        const modalEl = document.getElementById(modalId);
        if (!modalEl) {
            return;
        }

        const modalInstance = bootstrap.Modal.getInstance(modalEl)
            || bootstrap.Modal.getOrCreateInstance(modalEl);
        modalInstance.hide();
        setTimeout(cleanupModalBody, 300);
    };
      
      
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);

            setSelectedImage(URL.createObjectURL(file));
        }
    };

    useEffect(() => {
        const productcategory = async () => {
            try {

                const response = await axios.get(site_url + '/vendor/productcategory');

                if (response.data.status == 'success') {

                    setcategorydata(response.data.category);
                }
            } catch (error) {

            }
        }

        productcategory();
    }, [])

    useEffect(() => {
        productlist();
    }, [user])

    useEffect(() => {
      
    }, [editdetails])
    const productlist = async () => {
        try {

            const response = await axios.get(site_url + '/vendor/product_list/' + fulluser?.id);
         
            setproductlist(response.data.product);
            if (response.data.status == 'success') {


            }
        } catch (error) {

        }
    }
    const showSuccessAlert = () => {
        Swal.fire({
            title: 'Success!',
            text: 'Your bill has been created successfully',
            icon: 'success',
            confirmButtonText: 'OK',
        });
    };
    const confirmButtonText = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
          }).then((result) => {
            if (result.isConfirmed) {
                deleteget(id);
              Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                icon: "success"
              });
            }
          });
    };
    const deleteget = async (id) => {
        try {

            const response = await axios.get(site_url + '/vendor/product_delete/'+id);

            if (response.data.status == 'success') {

                productlist();
                closeProductModal('withdrawActionSheeta');
            }
        } catch (error) {

        }
    }
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        try {

           
            const data = {
                product_name: values.product_name,
                price: values.price,
                product_cate: values.product_cate,
                vid: fulluser?.id,
                product_image: image,
                pid: values.pid,
            }
           
            var url ='';
            if(values.formtype == 'create'){
                url = site_url +'/vendor/product_create';
            }else{
                url =  site_url +'/vendor/product_update';
            }
            const response = await axios.post(url, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
       

            if (response.data.status == 'success') {
                setSelectedImage(null)
                productlist();
                resetForm();
                showSuccessAlert();
                closeProductModal(values.formtype === 'create' ? 'withdrawActionSheet' : 'withdrawActionSheeta');
            } else if (response.data.status == 'failed') {

            }

            // Reset form after success
        } catch (error) {
            console.error(error);
        } finally {

        }
    };
    
    return (
        <div id="appCapsule">
            <h2 className='mt-3'>Product List</h2>
            {productdata.map((item) => (

                <div className="card mt-1" data-bs-toggle="modal"
                    data-bs-target="#withdrawActionSheeta"  onClick={()=> seteditdetails(item) } >
                    <div className="p-2">
                        <div className='row'>
                            <div className='col-4'>
                                <img
                                    src={site_url_img + '/' + item.product_image}
                                    alt="img"
                                    className="image-block imaged w100"
                                />
                            </div>
                            <div className='col-8'>
                                <br></br>
                                <strong style={{ color: 'black' }}>{item.product_name}</strong><br></br>
                                <b style={{ color: 'black' }}><IndianCurrencyFormatter amount={item.price} /></b><br></br>
                                <b style={{ color: 'red' }}>{item.name}</b>
                            </div>
                        </div>
                    </div>
                </div>
            ))}






            <button className="floating-btn" data-bs-toggle="modal"
                data-bs-target="#withdrawActionSheet">
                <ion-icon name="bag-outline"></ion-icon>
            </button>

            <div
                className="modal fade action-sheet"
                id="withdrawActionSheet"
                tabIndex={-1}
                role="dialog"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Product Details</h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => closeProductModal('withdrawActionSheet')}
                            />
                        </div>

                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <Formik
                                    initialValues={{formtype:'create', product_name: '', price: '', product_image: '', product_cate: '' ,pid:''}}
                                    validate={values => {
                                        const errors = {};

                                        if (!values.product_name) {
                                            errors.product_name = 'Product Name is required';
                                        }
                                        if (!values.price) {
                                            errors.price = 'Price is required';
                                        }


                                        return errors;
                                    }}
                                    onSubmit={handleSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        /* and other goodies */
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <label for="exampleInputEmail1"><b>Product Image</b></label>
                                            <div className="form-group">
                                                <input type="file" accept="image/*" onChange={handleImageChange} />
                                                {selectedImage && (
                                                    <div>
                                                        <h3>Image Preview:</h3>
                                                        <img src={selectedImage} alt="Preview" width="200" />
                                                    </div>
                                                )}
                                            </div>

                                            <label for="exampleInputEmail1"><b>Product Name</b></label>
                                            <div className="form-group">
                                                <label htmlFor="email">
                                                    <ion-icon name="bag-handle-outline"></ion-icon>
                                                </label>
                                                <input type="text" name="product_name" onChange={handleChange} onBlur={handleBlur} value={values.product_name} placeholder="Enter Product Name" />
                                            </div>
                                            {errors.product_name && touched.product_name && (<div><span className="error">{errors.product_name}</span><br></br></div>)}
                                            <label for="exampleInputEmail1"><b>Product Price</b></label>
                                            <div className="form-group">
                                                <label htmlFor="email">
                                                    <ion-icon name="bag-handle-outline"></ion-icon>
                                                </label>
                                                <input type="number" name="price" onChange={handleChange} onBlur={handleBlur} value={values.price} placeholder="Enter Product Price" />
                                            </div>
                                            {errors.price && touched.price && (<span className="error">{errors.price}</span>)}
                                            <label for="exampleInputEmail1"><b>Product Category</b></label>
                                            <div className="form-group">
                                                <select name='product_cate' onChange={handleChange} onBlur={handleBlur} class="form-select" aria-label="Default select example">
                                                    <option value="">Select Category</option>
                                                    {categorydata?.map((item) => (
                                                        <option value={item.id}>{item.name}</option>
                                                    ))}
                                                </select>

                                            </div>
                                            <div className="form-group basic">
                                            <button
                                                    type="button"
                                                    className="btn btn-danger btn-block btn-lg"
                                                    onClick={() => closeProductModal('withdrawActionSheet')}
                                                >
                                                   Close
                                                </button>
                                                <div style={{width:'5%'}} />
                                                <button
                                                    type="submit" disabled={isSubmitting}
                                                    className="btn btn-primary btn-block btn-lg"
                                                // data-bs-dismiss="modal"
                                                >
                                                    Create Product
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div
                className="modal fade action-sheet"
                id="withdrawActionSheeta"
                tabIndex={-1}
                role="dialog"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Product Details Edit </h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => closeProductModal('withdrawActionSheeta')}
                            />
                        </div>

                        <div className="modal-body">
                            <div className="action-sheet-content">
                                {(editdetails && 
                                <Formik
                                    initialValues={{ formtype:'update', product_name: editdetails.product_name, price: editdetails.price, product_image: '', product_cate: editdetails.id,pid: editdetails.pid }}
                                    enableReinitialize={true}
                                    validate={values => {
                                        const errors = {};

                                        if (!values.product_name) {
                                            errors.product_name = 'Product Name is required';
                                        }
                                        if (!values.price) {
                                            errors.price = 'Price is required';
                                        }


                                        return errors;
                                    }}
                                    onSubmit={handleSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        /* and other goodies */
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <label for="exampleInputEmail1"><b>Product Image</b></label>
                                            <div className="form-group">
                                                <input type="file" accept="image/*" onChange={handleImageChange} />
                                                {selectedImage && (
                                                    <div>
                                                        <h3>Image Preview:</h3>
                                                        <img src={selectedImage} alt="Preview" width="200" />
                                                    </div>
                                                )}
                                            </div>

                                            <label for="exampleInputEmail1"><b>Product Name</b></label>
                                            <div className="form-group">
                                                <label htmlFor="email">
                                                    <ion-icon name="bag-handle-outline"></ion-icon>
                                                </label>
                                                <input type="text" name="product_name" onChange={handleChange} onBlur={handleBlur} value={values.product_name} placeholder="Enter Product Name" />
                                            </div>
                                            {errors.product_name && touched.product_name && (<div><span className="error">{errors.product_name}</span><br></br></div>)}
                                            <label for="exampleInputEmail1"><b>Product Price</b></label>
                                            <div className="form-group">
                                                <label htmlFor="email">
                                                    <ion-icon name="bag-handle-outline"></ion-icon>
                                                </label>
                                                <input type="number" name="price" onChange={handleChange} onBlur={handleBlur} value={values.price} placeholder="Enter Product Price" />
                                            </div>
                                            {errors.price && touched.price && (<span className="error">{errors.price}</span>)}
                                            <label for="exampleInputEmail1"><b>Product Category</b></label>
                                            <div className="form-group">
                                                <select name='product_cate' onChange={handleChange} onBlur={handleBlur} class="form-select" aria-label="Default select example">
                                                    <option value="">Select Category</option>
                                                    {categorydata?.map((item) => (
                                                        <option selected={editdetails.id === item.id} value={item.id}>{item.name}</option>
                                                    ))}
                                                </select>

                                            </div>
                                            <div className="form-group basic">
                                            <button
                                                    type="button"
                                                    onClick={() => confirmButtonText(editdetails.pid)}
                                                    className="btn btn-danger btn-block btn-lg"
                                                >
                                                 Delete
                                                </button>
                                                <div style={{width:'5%'}} />
                                                <button
                                                    type="submit" disabled={isSubmitting}
                                                    className="btn btn-primary btn-block btn-lg"
                                                >
                                                    Update
                                                </button>
                                                <div style={{width:'5%'}} />
                                                <button
                                                    type="button"
                                                    className="btn btn-info btn-block btn-lg"
                                                    onClick={() => closeProductModal('withdrawActionSheeta')}
                                                >
                                                   Close
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
            <Sidebar />

        </div>
    )

}
